module.exports = __webpack_public_path__ + "static/media/fraises.cb881bec.svg";